import { render, staticRenderFns } from "./forget-username.vue?vue&type=template&id=c47a6ca6"
import script from "./forget-username.vue?vue&type=script&lang=js"
export * from "./forget-username.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports